import React from "react";

export const SectionHeading = ({ sectionheading }) => {
  return (
    <h1 className="mb-4  mt-4 text-xl font-extrabold leading-relaxed text-white lg:mt-8 lg:mb-4 lg:text-3xl">
      {sectionheading}
    </h1>
  );
};
